import { DATE_TIME_FORMAT } from '@risksmart-app/i18n/src/i18n';

/**
 * The platform's date format, with two deliberate changes for occurrence
 * windows: rendered in UTC because a window bound is a calendar day at midnight
 * UTC rather than an instant, and with the weekday shown because for a weekly
 * schedule the weekday is the only thing that distinguishes its occurrences.
 */
const SCHEDULE_DAY_FORMAT: Intl.DateTimeFormatOptions = {
  ...DATE_TIME_FORMAT,
  timeZone: 'UTC',
  weekday: 'short',
};

export const formatScheduleDay = (day: Date): string =>
  day.toLocaleDateString('en-GB', SCHEDULE_DAY_FORMAT);
